import { Component, Input } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import { webVersion } from "./web-version";
import { ServiceProCookieConsentButtonComponent } from "../../cookie-consent/service-pro-cookie-consent-button.component";

export interface UserInfoData {
    user: {
        initialer?: string;
        name: string;
        email: string;
        phone?: string;
        address?: string;
    };
    works: {
        name: string;
        address?: string;
        phone?: string;
    };
}

@Component({
    selector: "user-info",
    imports: [ServiceProCookieConsentButtonComponent],
    templateUrl: "./user-info.html",
    styleUrl: "./user-info.scss"
})
export class UserInfo {
    @Input()
    public data: UserInfoData | null = null;

    public readonly webVersion = webVersion;
    public readonly klientLabel = Capacitor.isNativePlatform() ? "app" : "browser";
}
